export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 2.7800000000000002,
        "transcript": "...llerpeni qaillun umyuarteqellrusit?",
        "translation": " ...when you [fist saw Caucasians], what did you think?"
    },
    "2": {
        "startTime": 2.98,
        "endTime": 7.61,
        "transcript": "Tua-i-w' irr'iluta pillrulriakut Yugni.",
        "translation": "Well, we Yupiit were amazed by them."
    },
    "3": {
        "startTime": 7.63,
        "endTime": 11.21,
        "transcript": "Alikluki-qaa wall'u-qaa qaillun?",
        "translation": "Were you scared of them or what?"
    },
    "4": {
        "startTime": 11.21,
        "endTime": 17.98,
        "transcript": "Tua-i-wa alikuciinaki-ll irr'ikluki tau͡gaam pillrulrianga wiinga.",
        "translation": "I had no sense of fear, but I was amazed by them."
    },
    "5": {
        "startTime": 17.98,
        "endTime": 20.39,
        "transcript": "Ilanka nallukenka.",
        "translation": "I don't know about the others."
    },
    "6": {
        "startTime": 20.39,
        "endTime": 21.82,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "7": {
        "startTime": 24.41,
        "endTime": 31.8,
        "transcript": "Nasaurlullraullerpeni tayima nasaurlurni elpeci alerquutengqellruuci.",
        "translation": "When you were a little girl, you girls probably had traditional instructions."
    },
    "8": {
        "startTime": 31.8,
        "endTime": 41.06,
        "transcript": "Man'a-llu maa-i niitelaqeka agleqarraalriit tua-i inerquutangqerraqluteng.",
        "translation": "Now, I also hear that those in their first year of menstruations have admonishments."
    },
    "9": {
        "startTime": 41.065,
        "endTime": 46.185,
        "transcript": "Tamana kitak' inerquutek'lallrat qalarutkeqerru.",
        "translation": "Please talk about their admonishments."
    },
    "10": {
        "startTime": 46.5,
        "endTime": 52.54,
        "transcript": "Tua-i nasaurlurluq agle'rqan ayagavkarpek'naku.",
        "translation": "When a girl had her first menstruations, they wouldn't let her travel."
    },
    "11": {
        "startTime": 52.545,
        "endTime": 57.42,
        "transcript": "Imkut yuit uitavkaraqekiit.",
        "translation": "They would have their children stay."
    },
    "12": {
        "startTime": 57.42,
        "endTime": 66.1,
        "transcript": "Makut-llu, makut-llu tan'gaurluut nulirtuqsailnguut mallguuravkarpek'naki.",
        "translation": "They would also keep her from getting too close to these unmarried boys."
    },
    "13": {
        "startTime": 66.105,
        "endTime": 76.115,
        "transcript": "Kencikluki cakneq aglenraraulrianun pitullrukait.",
        "translation": "They would watch them very carefully around those who were in the first year of menstruations."
    },
    "14": {
        "startTime": 76.455,
        "endTime": 85.625,
        "transcript": "Qalarutaqluki, nasaurluq tauna qalarutaqluku picirkaanek-w' ayuqucirtualuku",
        "translation": "They would speak to them, speak to that girl, instructing her about how she should be"
    },
    "15": {
        "startTime": 86.135,
        "endTime": 89.945,
        "transcript": "Aglellrurtellrani-ll' ayuqucianek.",
        "translation": "And what it's like when she's started menstruating."
    },
    "16": {
        "startTime": 90.305,
        "endTime": 100.735,
        "transcript": "Makut tan'gaurluutnek ayagyuatnek kencikluki cakneq pitullruit.",
        "translation": "They used to very carefully watch over their young boys."
    },
    "17": {
        "startTime": 100.735,
        "endTime": 105.595,
        "transcript": "Maa-i tuaten ayuqsugnairutut mat'um nalliini.",
        "translation": "Now, they're nothing like that these days."
    },
    "18": {
        "startTime": 105.78,
        "endTime": 108.3,
        "transcript": "Ayuqenrirtut.",
        "translation": "They're different now."
    },
    "19": {
        "startTime": 109.205,
        "endTime": 113.305,
        "transcript": "Qaillun kencik'lallruitki?",
        "translation": "How would they carefully watch over them?"
    },
    "20": {
        "startTime": 113.75,
        "endTime": 118.91,
        "transcript": "Camek inerquutarluteng pitullruat?",
        "translation": "What admonishment did they have to do that?"
    },
    "21": {
        "startTime": 118.915,
        "endTime": 121.61,
        "transcript": "Kencikluki, inerquutekluki.",
        "translation": "They carefully watched over them, admonished against them."
    },
    "22": {
        "startTime": 121.61,
        "endTime": 129.29,
        "transcript": "Makut-llu tan'gaurluut ayagyuat aneryaaravikesqevkenaki-llu.",
        "translation": "They also told them not to breathe on these young boys."
    },
    "23": {
        "startTime": 130.205,
        "endTime": 133.82,
        "transcript": "Mallguuravkenaki cakneq pisqelluki.",
        "translation": "They told the not to get too close to them."
    },
    "24": {
        "startTime": 133.82,
        "endTime": 141.06,
        "transcript": "Cali-llu tua-i maa-i tang nuyavluliurangelriit.",
        "translation": "Also, they always have messy hair now."
    },
    "25": {
        "startTime": 141.065,
        "endTime": 144.535,
        "transcript": "Cali-llu nuyavluliqaqaunrirluki.",
        "translation": "They also told them never to have messy hair."
    },
    "26": {
        "startTime": 147.255,
        "endTime": 151.475,
        "transcript": "Nuyavluliqaasqevkenaki.",
        "translation": "They told them never to have messy hair."
    },
    "27": {
        "startTime": 152.03,
        "endTime": 162.69,
        "transcript": "Angun-llu tamana ayagyuaq neqkiuqatgu agu nuyavlulisqevkenaki piaqluki.",
        "translation": "And when they made food for a young man, they told them never to have messy hair."
    },
    "28": {
        "startTime": 163.095,
        "endTime": 170.055,
        "transcript": "Unatait-llu tau͡gaam cali erurraarluki neq'liuresqaqluki.",
        "translation": "And they said that only after washing their hands to work on fish."
    },
    "29": {
        "startTime": 170.77,
        "endTime": 177.0,
        "transcript": "Kencikluki tamaa-i. Kencikutelallruit tamaa-i.",
        "translation": "That was how they carefully watched them. They'd carefully watch them then."
    },
    "30": {
        "startTime": 177.0,
        "endTime": 188.21,
        "transcript": "Camek-mi kangingqellinia una wani tan'gaurlurmun aneryaaraasqevkenaku? Wall'u uq'lirnerakun ayaasqutii camek kangingqerta?",
        "translation": "So, what's the meaning behind not breathing on a boy? Or what's the meaning because going downwind from him?"
    },
    "31": {
        "startTime": 188.51,
        "endTime": 190.8,
        "transcript": "Kangingqellrullinia?",
        "translation": "What did it mean?"
    },
    "32": {
        "startTime": 190.87,
        "endTime": 199.93,
        "transcript": "Tan'gaurluq-gguq tauna aglellrurtellriamek kenkiamek qaillun piaqameng",
        "translation": "They say that when that boy makes love to one in the first year of her menstruations, when something happens"
    },
    "33": {
        "startTime": 201.095,
        "endTime": 208.385,
        "transcript": "Yun'erraq assiirut'lartuq, qaillun ellirluni, usviirulluni-llu.",
        "translation": "A young man becomes bad, becomes abnormal, and lacks common sense."
    },
    "34": {
        "startTime": 209.465,
        "endTime": 217.045,
        "transcript": "Tua-i tamaa-i alikutiit aglellrurtellrianun makunun nasaurlurnun.",
        "translation": "That is what they feared about these girls within the first year of their menstruations."
    },
    "35": {
        "startTime": 224.43,
        "endTime": 226.9,
        "transcript": "Neq'liuryaurtellerpeni-mi?",
        "translation": "What about when you started working on fish?"
    },
    "36": {
        "startTime": 226.9,
        "endTime": 233.03,
        "transcript": "Neqa wani camek cali una alerquutengqellrua?",
        "translation": "What traditional instructions were there about fish?"
    },
    "37": {
        "startTime": 233.03,
        "endTime": 237.37,
        "transcript": "Tayima cat tamarmeng alerquutengqellruut avani.",
        "translation": "Everything had traditional isntructions back then."
    },
    "38": {
        "startTime": 237.379,
        "endTime": 241.739,
        "transcript": "Neqa qaillun arcaqerluku alerquutek'lallruatgu?",
        "translation": "What did they especially instruct about fish?"
    },
    "39": {
        "startTime": 243.074,
        "endTime": 254.104,
        "transcript": "Neqa-wa cakneq tua-i makunun-llu nasaurlurnun ayagyuanun irniameggnun alerquutekluku",
        "translation": "They would give a lot of traditional instructions about fish to these young girls, their children"
    },
    "40": {
        "startTime": 254.104,
        "endTime": 256.584,
        "transcript": "Kencikluku, kenekluku.",
        "translation": "To treat it with reverence and love."
    },
    "41": {
        "startTime": 256.589,
        "endTime": 262.189,
        "transcript": "Neqa cakneq uqlautevkenaku, tut'marpek'naku-llu.",
        "translation": "Don't make a mess of fish too much, or trample upon it."
    },
    "42": {
        "startTime": 263.114,
        "endTime": 267.384,
        "transcript": "Neqraq un' taigaqan kuvyassu'urqan-llu",
        "translation": "When a little fish comes when they drift net"
    },
    "43": {
        "startTime": 267.674,
        "endTime": 277.904,
        "transcript": "Atauciungraan-llu assircaarluku ullirrluku, iniluku, nernarian ner'aqluku.",
        "translation": "Even if it's just one, cut it well, hang it to dry, and eat it when it's time."
    },
    "44": {
        "startTime": 277.904,
        "endTime": 287.564,
        "transcript": "Tau͡gken-gguq tamaani cailkami uitaskatni, uitakuni tamaani aruluni.",
        "translation": "However, they said that if they leave it strewn, it'll rot if it stays there."
    },
    "45": {
        "startTime": 287.569,
        "endTime": 292.409,
        "transcript": "Ciissit-llu paralut nerluku, piunrirluku tua-i.",
        "translation": "And the bugs, maggots, will eat it, destroying it."
    },
    "46": {
        "startTime": 294.364,
        "endTime": 302.234,
        "transcript": "Tuaten pisqevkenaki pitullruit neqalleruaraat kenekluki cakneq.",
        "translation": "They told them not to do that out of great love for what fish they had."
    },
    "47": {
        "startTime": 302.444,
        "endTime": 308.504,
        "transcript": "Kinraqata qemagtaqluki, qemanqegcarluki.",
        "translation": "When they dried, they'd store them, store them well."
    },
    "48": {
        "startTime": 309.609,
        "endTime": 314.369,
        "transcript": "Neqalleruaraat caassakevkenaki.",
        "translation": "They didn't waste what fish they had."
    },
    "49": {
        "startTime": 314.884,
        "endTime": 324.264,
        "transcript": "Qimugteńun-llu nallaita nerngailketeng nerevkaraqluki cailkamcetevkenaki.",
        "translation": "And what they wouldn't eat among them, they'd feed to the dogs, not leave them strewn about."
    },
    "50": {
        "startTime": 324.589,
        "endTime": 329.984,
        "transcript": "Cali-ll' neqallret natmun ciqiqurluki.",
        "translation": "Also, they always dumped the food scraps somewhere."
    },
    "51": {
        "startTime": 329.984,
        "endTime": 336.414,
        "transcript": "Tutmallrunrilngurmun yuilqumun neqallret ciqisvigluteng.",
        "translation": "Food scraps had dumping sites in the wilderness where people didn't trod."
    },
    "52": {
        "startTime": 336.644,
        "endTime": 343.854,
        "transcript": "Qurrutet-llu ciqisviitnun piyuunaki, tau͡gaam tamaavet yuilqumun.",
        "translation": "They wouldn't dump them in the dumping sites for honey bucket, but there in the wilderness."
    },
    "53": {
        "startTime": 344.104,
        "endTime": 347.744,
        "transcript": "Kenekluku cakneq neqa.",
        "translation": "They treated fish with great love."
    },
    "54": {
        "startTime": 348.359,
        "endTime": 357.299,
        "transcript": "Camek-llu-w' imumi Kass'artarnek-llu neryuitellruameng, kiingita neqkelaamegteki",
        "translation": "And since they didn't eat Western food long ago, since it was their only food source"
    },
    "55": {
        "startTime": 358.109,
        "endTime": 368.669,
        "transcript": "Tamakut makut neqet cakneq kenkevkarluki ayuqucirtuutekluki-ll' ayagyuameggnun.",
        "translation": "They instructed their youth to treath these fish with great love."
    },
    "56": {
        "startTime": 369.104,
        "endTime": 377.774,
        "transcript": "Ciqirqesqevkenaki-ll' piciatun pinaurait, tutmaasqevkenaki.",
        "translation": "And they'd tell them not to dump them in random places, not to tread over them."
    },
    "57": {
        "startTime": 378.214,
        "endTime": 384.804,
        "transcript": "Neqalleruaraat caassakevkenaki.",
        "translation": "They didn't waste what fish they had."
    },
    "58": {
        "startTime": 385.634,
        "endTime": 392.124,
        "transcript": "Maa-i wani allrakuten yuinaat cetaman.",
        "translation": "Now, you're 80 years old."
    },
    "59": {
        "startTime": 392.674,
        "endTime": 397.294,
        "transcript": "Ak'a avani murilkessaurtellerpeni",
        "translation": "Back when you started becoming observant"
    },
    "60": {
        "startTime": 398.539,
        "endTime": 402.894,
        "transcript": "Maa-i ernemcetun ayuqellrunrituq nallunailngurmek.",
        "translation": "It's clear that it wasn't like our current day."
    },
    "61": {
        "startTime": 402.894,
        "endTime": 409.374,
        "transcript": "Ernemteńi cat, cat paivutaitekut amlleq.",
        "translation": "In our days, many things don't need to be set out."
    },
    "62": {
        "startTime": 409.379,
        "endTime": 419.729,
        "transcript": "Qaillun elpet murilkellerpeni cimiutii, cat cimirpagtat maa-i murilkurallerpeni una erneq tekilluku?",
        "translation": "The changes you've seen in your observation, what are the biggest changes in your observation to this day?"
    },
    "63": {
        "startTime": 420.349,
        "endTime": 422.444,
        "transcript": "Makut-qaa ayuqucit?",
        "translation": "You mean what things are like?"
    },
    "64": {
        "startTime": 422.444,
        "endTime": 427.384,
        "transcript": "Ii-i, ayuqucit, yuum-llu ayuqucia, Yugni wangkuta ayuqucirput.",
        "translation": "Yes, what things are like, and what a person is like, what we Yupiit are like."
    },
    "65": {
        "startTime": 427.389,
        "endTime": 431.089,
        "transcript": "Tua-i-w' ayuqucirput tamamta cimiliria.",
        "translation": "What all of us are like has changed."
    },
    "66": {
        "startTime": 431.234,
        "endTime": 437.314,
        "transcript": "Ak'acetun ayuqsugnairulluta, assiirulluta tua-i.",
        "translation": "We're nothing like long ago, having become bad."
    },
    "67": {
        "startTime": 438.039,
        "endTime": 444.489,
        "transcript": "Makut-llu ayagyuaput qanruteqtangramceteng niicuirulluteng.",
        "translation": "And even when we speak to our youth, they don't listen anymore."
    },
    "68": {
        "startTime": 444.839,
        "endTime": 447.809,
        "transcript": "Maligtaqucuirulluteng.",
        "translation": "They don't obey anymore."
    },
    "69": {
        "startTime": 447.809,
        "endTime": 453.059,
        "transcript": "Assiilnguq tau͡gaam ellaita piyullerteng cumigulluku.",
        "translation": "They only focus on the bad things they want to do."
    },
    "70": {
        "startTime": 453.059,
        "endTime": 465.599,
        "transcript": "Wangkuta pisqutput aturciigaliluku makut tan'gaurluut nasaurluut-llu maa-i mat'um nalliini.",
        "translation": "These boys and girls can't follow our commandments these days."
    },
    "71": {
        "startTime": 465.934,
        "endTime": 474.814,
        "transcript": "Maa-i tuaten wangkuta pisqumcimcetun angayuqameggni piyukuneng",
        "translation": "If they want to treat their parents as we were commanded to like that"
    },
    "72": {
        "startTime": 474.959,
        "endTime": 481.549,
        "transcript": "Assirluteng yuular[lit], qingaqsaunateng-ll' uingunateng, qingayuunateng.",
        "translation": "They'd live well, and would not become pregnant without husbands, wouldn't become pregnant."
    },
    "73": {
        "startTime": 481.549,
        "endTime": 484.464,
        "transcript": "Maa-i amlleriluteng-llu tamakut.",
        "translation": "There are now many of those."
    },
    "74": {
        "startTime": 484.464,
        "endTime": 491.164,
        "transcript": "Angayuqateng cakevkenaki. Pingraiceteng niicuirulluteng.",
        "translation": "They don't respect their parents. Though they're told, they don't listen anymore."
    },
    "75": {
        "startTime": 492.259,
        "endTime": 499.574,
        "transcript": "Cam, cam-kiq tua-i niicuirucetakut wangkuta amllerni ayagyuani?",
        "translation": "I wonder what's making many of us young people disobedient?"
    },
    "76": {
        "startTime": 499.574,
        "endTime": 508.074,
        "transcript": "Ciin, ciin tuaten elpeni murilkellerpeni cali ciin maligtaqutenrissiyaagceta?",
        "translation": "Why, in your observation also, why are we so disobedient now?"
    },
    "77": {
        "startTime": 508.079,
        "endTime": 512.089,
        "transcript": "Wiinga-ll' umyuarteq'laryaaqua tuaten.",
        "translation": "I also think like that too."
    },
    "78": {
        "startTime": 512.089,
        "endTime": 520.619,
        "transcript": "Camun? Wall'u angayuqrita makut maligtaquurluki?",
        "translation": "From what? Or is it because they follow their parents?"
    },
    "79": {
        "startTime": 520.619,
        "endTime": 528.019,
        "transcript": "Wall'u pilaryukluki? Camun piciinaki umyuaqa pilartuq.",
        "translation": "Or do they think their [parents] do it? I have no idea what makes them like that."
    },
    "80": {
        "startTime": 528.444,
        "endTime": 538.514,
        "transcript": "Makut tang ayagyuarluput-wa tua-i assircetengnaqengramceteng assiryugpek'nateng.",
        "translation": "You see, though we try to make our youth good, they don't tend to turn out good."
    },
    "81": {
        "startTime": 538.854,
        "endTime": 547.684,
        "transcript": "Mat'um-llu taangam arcaqangekai tan'gaurluut, ayagyuat-wa tua-i.",
        "translation": "This alcohol also makes it worse for boys, the young ones."
    },
    "82": {
        "startTime": 549.554,
        "endTime": 554.254,
        "transcript": "Taangiqellriamek tangerqerraallerpeni qaillun pillrusit?",
        "translation": "When you first saw someone drunk, what did you do?"
    },
    "83": {
        "startTime": 554.779,
        "endTime": 560.389,
        "transcript": "Tua-i-w' irr'ilua qaillun piciilkenka usviinateng imkut.",
        "translation": "I was staring, not knowing what was going on with them acting insensibly."
    },
    "84": {
        "startTime": 561.099,
        "endTime": 569.459,
        "transcript": "Kanani Mamterillermek ayagluteng tuaten pilangluteng.",
        "translation": "Going from Bethel down there, they started doing that."
    },
    "85": {
        "startTime": 570.234,
        "endTime": 574.154,
        "transcript": "Tua-i ellakevkenateng usviinateng.",
        "translation": "They acted senselessly and foolishly."
    },
    "86": {
        "startTime": 574.699,
        "endTime": 582.769,
        "transcript": "Qaillun, wangkuta-ll' qaillun tamatutuqsailngurni pilauciit nalluluki.",
        "translation": "And we who've never had that didn't know that they did."
    },
    "87": {
        "startTime": 583.669,
        "endTime": 586.159,
        "transcript": "Tau͡gaam inerqularyaaqluki.",
        "translation": "But we would admonish them."
    },
    "88": {
        "startTime": 586.159,
        "endTime": 592.229,
        "transcript": "Tua-i pimariaqameng inerqung'e'rmeng niicuirutaqluteng",
        "translation": "When they do it, though we admonish them, they don't listen anymore"
    },
    "89": {
        "startTime": 592.709,
        "endTime": 600.709,
        "transcript": "Piqtangramceteng tuaten pisqumavkenaki, pisqumanricaaqluki.",
        "translation": "Though we tell them not to do that, that we don't want them to do that."
    },
    "90": {
        "startTime": 604.734,
        "endTime": 612.894,
        "transcript": "Camek tayima elpet ayagyuat camek paitarkicugciki?",
        "translation": "What do you want to leave with the young people?"
    },
    "91": {
        "startTime": 613.539,
        "endTime": 621.039,
        "transcript": "Qaillun umyuaqesqumasit elpet wani kingunevnun?",
        "translation": "How do you want to be remembered by your descendants?"
    },
    "92": {
        "startTime": 623.624,
        "endTime": 624.724,
        "transcript": "Qaillun?",
        "translation": "What do you mean?"
    },
    "93": {
        "startTime": 624.729,
        "endTime": 632.269,
        "transcript": "Camek elpet tua-i paitarkangqerkuvet, paitarkangqerkuvet wangkutnun kingunerpenun",
        "translation": "If you have something you'd like to leave us with, leave with us, your descendants"
    },
    "94": {
        "startTime": 632.834,
        "endTime": 639.364,
        "transcript": "Cauga tauna umyuaqek'ngan arcaqalria wangkutnun umyuaqesqumakek'ngan?",
        "translation": "What is something important you can think of that you want us to remember?"
    },
    "95": {
        "startTime": 639.394,
        "endTime": 645.274,
        "transcript": "Assirluci ayagyuani yuusqumayaaqluci.",
        "translation": "I want you young people to live well."
    },
    "96": {
        "startTime": 645.691,
        "endTime": 660.121,
        "transcript": "Aipangaqata-llu aipait cali piluki elluarrluki piurluki kenekluki pisqumalallruaput wangkuta, pisqumalaraput.",
        "translation": "And when they get married, we'd want them, we want them to treat their spouses well and to love them."
    },
    "97": {
        "startTime": 660.575,
        "endTime": 671.13,
        "transcript": "Qaillun pivkenaki, ilait-llu nangcitulaata tuaten pisqevkenaki inerquraqtaryaaqelaqeput ayagyuaput.",
        "translation": "Without treating them badly, also because some are abusive, we admonish our youth not to do that."
    },
    "98": {
        "startTime": 671.324,
        "endTime": 683.789,
        "transcript": "Assirluki cali neqkarcuqagnek neqalleruaraat auluklerkaatnek alerquraqtaraqluki.",
        "translation": "Also, if they gather food, we instruct them to take good care of what food they have."
    },
    "99": {
        "startTime": 683.804,
        "endTime": 687.86,
        "transcript": "Alerquagaqluki-w' tua-i tuaten pisqelluki.",
        "translation": "We instruct them to do that."
    },
    "100": {
        "startTime": 687.874,
        "endTime": 694.908,
        "transcript": "Kenekluki cakneq tamakut aulukesqelluki assingnaqluki.",
        "translation": "We tell them to take care of those with great love so that they'll be good."
    },
    "101": {
        "startTime": 695.13,
        "endTime": 703.041,
        "transcript": "Yugnun-llu nerevkalaitki, cali cikiqaqutekluki piilngurnun",
        "translation": "Also, because they feed people, and give to those who have none"
    },
    "102": {
        "startTime": 703.346,
        "endTime": 711.791,
        "transcript": "Tamaa-i tamaaggun assirluki piuraasqumaluki neqet, neqalleruaraat.",
        "translation": "Through that, we tell them to always prepare their food, what food they have, well."
    },
    "103": {
        "startTime": 712.972,
        "endTime": 722.583,
        "transcript": "Neqa una qaill' ayuqengraan kinercirluku, assircaarluku taq'aqluku.",
        "translation": "No matter what this fish is like, dry it, and prepare it well."
    },
    "104": {
        "startTime": 722.594,
        "endTime": 732.316,
        "transcript": "Piunrirarkaunrirluku aruarkaunrirluku-ll' kinenqegcaartelluku qemagtaqluki, qemaggluki.",
        "translation": "Dry it so that it won't spoil or rot, and store them."
    },
    "105": {
        "startTime": 732.505,
        "endTime": 746.949,
        "transcript": "Ellivingqetullermeggni ellivignun elliluki cakneq piluki kenekluki piutekaqluki neqalleruaraat assinrilengraata.",
        "translation": "When they had caches, they'd put what fish they had into caches out of great love though they [seemed] bad."
    },
    "106": {
        "startTime": 749.528,
        "endTime": 753.872,
        "transcript": "Tua-i tamaa-i tamakut wangkutnun ayuqucirt[uutet].",
        "translation": "Those were our traditional instructions."
    },
    "107": {
        "startTime": 753.898,
        "endTime": 765.829,
        "transcript": "Wiinga-ll' tua-i tuaten ciuqlima uitavillma piciryaraatnek alerquutaitnek-llu atungnaqurallruunga.",
        "translation": "I also tried to practice the ways and instructions of the first place I lived."
    },
    "108": {
        "startTime": 765.834,
        "endTime": 770.745,
        "transcript": "Kiituani waniw' casciigalilua uitangua.",
        "translation": "Eventually, I can't do anything anymore and stay here now."
    },
    "109": {
        "startTime": 771.507,
        "endTime": 778.04,
        "transcript": "Qaillun man' piniarulluni ellaka cakugtesciigalilua.",
        "translation": "My body's become weak, and I can't work hard anymore."
    },
    "110": {
        "startTime": 780.244,
        "endTime": 781.488,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "111": {
        "startTime": 781.498,
        "endTime": 789.531,
        "transcript": "Tua-i-ngulria-wa. Wiinga allamek apyutkailngua. Camek tau͡gaam qanqeryukuvet cali ilaqeryukuvgu qalarqurallren.",
        "translation": "That's it. I have no other questions. But if you want to say something to add to what you've said."
    },
    "112": {
        "startTime": 791.74,
        "endTime": 794.784,
        "transcript": "Tua-i-ngullilrianga wiinga.",
        "translation": "I think that's it for me."
    },
    "113": {
        "startTime": 795.725,
        "endTime": 799.392,
        "transcript": "Tua-i-wa tangrrutaqamta quyalalrianga.",
        "translation": "Well, I'm glad when we see each other."
    },
    "114": {
        "startTime": 800.642,
        "endTime": 802.098,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "115": {
        "startTime": 802.102,
        "endTime": 808.868,
        "transcript": "Elpet-llu tua-i tangvauralaqemken imkutgun makutgun TV-tgun. (Ii-i.)",
        "translation": "I also regularly watch you on the TV here. (I see.)"
    },
    "116": {
        "startTime": 808.893,
        "endTime": 810.082,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "117": {
        "startTime": 810.109,
        "endTime": 812.354,
        "transcript": "Tangvaurluten tua-i.",
        "translation": "I watch you."
    },
    "118": {
        "startTime": 816.053,
        "endTime": 818.253,
        "transcript": "Tua-i-nguyugnarquq tua-i.",
        "translation": "I think that's it."
    }
};